// @flow
import * as orgsTypes from 'app/common/constants/schools/types';


const getTranslateIdWithOrgTypePrefix = (key: string, currentOrgType: string): string => {
  if (currentOrgType === orgsTypes.HIGH_SCHOOL) {
    return `high_school_${key}`;
  }
  return key;
};


export default getTranslateIdWithOrgTypePrefix;
